import {createContext} from 'react';

import {FeatureFlagContextValues} from './FeatureFlagProvider';

export const FeatureFlagContext = createContext({} as FeatureFlagContextValues);
